module.exports = [
  {
      id: 'custom-board',
      title: 'Custom Board',
      icon: require('@/assets/images/boards/icons/blank-board.svg'),
      coverImage: require('@/assets/images/boards/adaptive-learning.svg'),
      backgroundColor: 'linear-gradient(142.84deg, #F8BE17 7.19%, #F29300 126.6%)',
      shortDescription: 'Create a board from scratch. Create your own use case and manage people as per your requirements.',
      description: 'Create a board from scratch. Create your own use case and manage people as per your requirements.',
      defaultApps: ['resume-editor'],
      optionalApps: ['resume-parser', 'resume-editor', 'abilities', 'alex', 'journey', 'coach','videowiki-cast','market']
  },
  {
      id: 'team',
      title: 'Team',
      icon: require('@/assets/images/boards/icons/team.svg'),
      coverImage: require('@/assets/images/boards/icons/team.svg'),
      backgroundColor: 'linear-gradient(0deg, #FF824D 0%, #FFD600 100%)',
      shortDescription: 'Meet all your team members at one place and collaborate with multiple teams. Know how your teams...',
      description: 'Meet all your team members at one place and collaborate with multiple teams! Know how your teams are working and get status updates on boards.',
      defaultApps: ['resume-editor', 'resume-parser','videowiki-cast'],
  },
  {
      id: 'hiring',
      title: 'Hiring',
      icon: require('@/assets/images/boards/icons/hiring.svg'),
      coverImage: require('@/assets/images/boards/icons/hiring.svg'),
      backgroundColor: 'linear-gradient(321.69deg, #FF6188 0%, #FFB199 100%)',
      shortDescription: 'Manage all applicants on your talent boards with an intuitive experience for candidate screening...',
      description: 'Manage all applicants on your talent boards with an intuitive experience for candidate screening, interviews and hiring processes.',
      defaultApps: ['resume-editor', 'abilities', 'resume-parser','videowiki-cast'],
  },
  {
      id: 'on-boarding',
      title: 'On-Boarding',
      icon: require('@/assets/images/boards/icons/on-boarding.svg'),
      coverImage: require('@/assets/images/boards/icons/on-boarding.svg'),
      backgroundColor: 'linear-gradient(146.32deg, #5585FF -16.37%, #A8C0FF 103.33%)',
      shortDescription: 'Automate your talent onboarding. Offer a step by step onboarding journey to your new joiners to learn...',
      description: 'Automate your talent onboarding. Offer a step by step onboarding journey to your new joiners to learn about your organization and get access to custom training library.',
      defaultApps: ['journey', 'alex', 'resume-editor', 'abilities', 'resume-parser'],
  },
  {
      id: 'classrooms',
      title: 'Classrooms',
      icon: require('@/assets/images/boards/icons/classrooms.svg'),
      coverImage: require('@/assets/images/boards/icons/classrooms.svg'),
      backgroundColor: 'linear-gradient(143.36deg, #D6FF94 3.66%, #3DC24B 103.19%)',
      shortDescription: 'Turn your board into a classroom by conducting online classes for your students. A collaboration board with...',
      description: 'Turn your board into a classroom by conducting online classes for your students. A collaboration board with loads of teaching tools to teach and learn together. Manage multiple boards as classes with different students.',
      defaultApps: ['resume-editor', 'resume-parser','videowiki-cast'],
  },
  {
      id: 'adaptive-learning',
      title: 'Adaptive learning',
      icon: require('@/assets/images/boards/icons/adaptive-learning.svg'),
      coverImage: require('@/assets/images/boards/icons/adaptive-learning.svg'),
      backgroundColor: 'linear-gradient(321.69deg, #4481EB 0%, #04BEFE 100%)',
      shortDescription: 'ALEX is a learning recommendations assistant for relevant skill development based on identified...',
      description: 'ALEX is a learning recommendations assistant for relevant skill development based on identified skill and personality gaps. Implement micro-learning and distributed development for your talent.',
      defaultApps: ['alex', 'resume-editor', 'abilities', 'resume-parser','market'],
  },
  {
      id: 'career-fair',
      title: 'Career Fair',
      icon: require('@/assets/images/boards/icons/career-fair.svg'),
      coverImage: require('@/assets/images/boards/adaptive-learning.svg'),
      backgroundColor: 'linear-gradient(143.36deg, #A18CD1 3.66%, #FBC2EB 103.19%)',
      shortDescription: 'Match students to companies and host a virtual career fair using this board configuration. Student...',
      description: 'Match students to companies and host a virtual career fair using this board configuration. Student profiling is done intuitively to attract companies to make contact and conduct spot interviews.',
      defaultApps: ['resume-editor', 'abilities', 'resume-parser'],
  },
  {
      id: 'coaching',
      title: 'Coaching',
      icon: require('@/assets/images/boards/icons/coaching.svg'),
      coverImage: require('@/assets/images/boards/adaptive-learning.svg'),
      backgroundColor: 'linear-gradient(143.36deg, #61FFC6 3.66%, #03BF9B 103.19%)',
      shortDescription: 'Add coaches or trainers on your boards to assist and manage individual development. Measure...',
      description: 'Add coaches or trainers on your boards to assist and manage individual development. Measure progress of training with structured engagement and feedbacks with MyCoach.',
      defaultApps: ['coach', 'resume-editor', 'abilities', 'resume-parser','videowiki-cast'],
  }
]

